module.exports = __webpack_public_path__ + "static/media/MCAST.f8bdd15e.png";